import React from 'react';
import './css/DestinationPopover.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ResortsPopup from './ResortsPopup/ResortsPopup';
import SearchResultPopup from './SearchResultPopup/SearchResultPopup';
import {
  changeSearchResult,
  changeResortOptions,
} from '../../../DataStore/actions/searchFormActions';

const mapStateToProps = (state) => ({ ...state });

class DestinationPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { changeSearchResult: changeSearchResultFunc } = this.props;

    changeSearchResultFunc([]);
  }

  render() {
    const { searchResult } = this.props;
    return (
      <div className="sf_destination_popover_w">
        {searchResult.length === 0 ? <ResortsPopup /> : <SearchResultPopup />}
      </div>
    );
  }
}

DestinationPopover.propTypes = {
  searchResult: PropTypes.instanceOf(Array).isRequired,
  changeSearchResult: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeSearchResult,
  changeResortOptions,
})(DestinationPopover);
